import moment from 'moment';

export class MerchantListRequest {
    constructor(params) {
        this.pageNumber = params.pageIndex ?? 1;
        this.pageSize = params.pageSize ?? 10;
        this.sort = 'createdOn';
        this.entityType = 'MERCHANT';
        this.enterpriseMerchant = true;
        this.axisMid = params.axisMid ?? null;
        this.createdBy = params.createdBy ?? null;
        this.mode = params.mode ?? null;
        this.source = params.source ?? null;
        this.merchantId = params.merchantId ?? null;
        this.status = params.status ?? 'ACTIVE';

        if (params.createdOn?.startDate && params.createdOn?.endDate) {
            const start = moment(params.createdOn.startDate).format('YYYY-MM-DD');
            const end = moment(params.createdOn.endDate).format('YYYY-MM-DD');
            this.createdOn = `btn:${start},${end}`;
        } else {
            this.createdOn = null;
        }
    }
}
